import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/providers";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getProvidersListSaga({ payload }) {
  try {
    const response = yield call(apis.getProvidersList, payload);
    yield put(
      actions.getProvidersResponse({
        list: response.data.service_providers,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        }, 
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getProvidersRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addProviderSaga({ payload }) {
  try {
    yield call(apis.addProvider, payload);
    yield showSuccessMsg("addedSuccessfully");
    yield history.push(ROUTE_PATHS.serviceProviders);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editProviderSaga({ payload }) {
  try {
    const response = yield call(apis.editProvider, payload);
    yield showSuccessMsg("editedSuccessfully");
    yield put(actions.getRequestStatus(response?.data?.success));
    if (!payload.data.status) {
      yield history.push(ROUTE_PATHS.viewServiceProvider.replace(':id',payload.id));
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
    yield put(actions.getRequestStatus(error.response?.data?.success));
  }
}

function* getProviderSaga({ payload }) {
  try {
    const response = yield call(apis.getProviderDetails, payload);
    yield put(
      actions.getProviderDetailsResponse(response.data.service_provider)
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
    yield put(actions.getGeneratedPasswordResponse(null)); 
  }
}

function* getGeneratedPasswordSaga({ payload }) {
  try {
    const response = yield call(apis.getGeneratedPassword, payload);
    yield put(actions.getGeneratedPasswordResponse(response.data.password));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteProviderSaga({ payload }) {
  try {
    yield call(apis.deleteProvider, payload);
    yield showSuccessMsg("deletedSuccessfully");

    if (payload.currentPage) {
      yield put(
        actions.getProvidersRequest({
          items: 10,
          page: payload.currentPage,
        })
      );
    } else {
      yield history.push(ROUTE_PATHS.serviceProviders);
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* ProvidersSagas() {
  yield takeEvery(types.GET_PROVIDERS_REQUEST, getProvidersListSaga);
  yield takeEvery(types.ADD_PROVIDER_REQUEST, addProviderSaga);
  yield takeEvery(types.GET_PROVIDER_DETAILS_REQUEST, getProviderSaga);
  yield takeEvery(types.EDIT_PROVIDER_REQUEST, editProviderSaga);
  yield takeEvery(types.DELETE_PROVIDER_REQUEST, deleteProviderSaga);
  yield takeEvery(
    types.GET_GENERATED_PASSWORD_REQUEST,
    getGeneratedPasswordSaga
  );
}
